import { isObject, merge } from 'lodash-es'

export default {
  get(key) {
    return localStorage.getItem(key)
  },

  getJSON(key) {
    const value = this.get(key)

    return value && JSON.parse(value)
  },

  set(key, val) {
    if (isObject(val)) {
      return localStorage.setItem(key, JSON.stringify(val))
    }

    return localStorage.setItem(key, val)
  },

  updateJSON(key, val) {
    const currentVal = this.getJSON(key) || {}

    return this.set(key, merge(currentVal, val))
  },

  remove(key) {
    return localStorage.removeItem(key)
  },
}
